export const UrlParamNames = {
    TrainingContractAccessCode: "trainingContractAccessCode",
    ConversationId: "conversationId",
};
